import { styled, Theme } from '@mui/material/styles';
import {
  AuditActionTone,
  getAuditActionTone,
} from './AuditLogAdminPageHelpers';

const toneColors = (theme: Theme, tone: AuditActionTone) => {
  switch (tone) {
    case 'success':
      return {
        background: theme.palette.green50,
        color: theme.palette.green700,
      };
    case 'danger':
      return {
        background: theme.palette.red50,
        color: theme.palette.red600,
      };
    case 'info':
      return {
        background: theme.palette.blue50,
        color: theme.palette.blue500,
      };
    default:
      return {
        background: theme.palette.grey100,
        color: theme.palette.grey600,
      };
  }
};

const AuditLogActionChip = ({
  action,
  label,
}: {
  action: string;
  label: string;
}) => (
  <Chip tone={getAuditActionTone(action)}>
    <Dot />
    {label}
  </Chip>
);

const Chip = styled('span', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: AuditActionTone }>(({ theme, tone }) => ({
  ...toneColors(theme, tone),
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 500,
  lineHeight: '16px',
  whiteSpace: 'nowrap',
}));

const Dot = styled('span')({
  width: 6,
  height: 6,
  borderRadius: '50%',
  background: 'currentColor',
  flexShrink: 0,
});

export default AuditLogActionChip;
